import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceover: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVoiceover"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM10 9.5H8V14.5H10L11.5 16.5H13V7.5H11.5L10 9.5ZM13.9004 10.2998C15.0335 11.1498 15.0335 12.8502 13.9004 13.7002L15.0996 15.2998C17.2996 13.6498 17.2996 10.3502 15.0996 8.7002L13.9004 10.2998Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceover;
